<template lang="pug">
div.wrap-item-tool-selector.f.fm
  div(v-for="tool in tools"
    :data-tg-tour="tool.tg.tour"
    :data-tg-order="tool.tg.order"
    :data-tg-group="tool.tg.group"
    @click="onTool(tool.mode)"
    @mouseover="hoveredIconMode = tool.mode"
    @mouseleave="hoveredIconMode = null"
    :class="{'active': currentMode == tool.mode}").wrap-tool.f.fh.cursor-pointer.mr8
    v-icon(size="18px" dark) {{tool.icon}}
    div(:class="{'hoverring': hoveredIconMode == tool.mode}").wrap-info.f.fh.px8
      span.fz14.pb2.text-center {{tool.name}}
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
$info_width: 120px;
.wrap-item-tool-selector {
  .wrap-tool {
    position: relative;
    width: 36px; height: 36px;
    background: $active_color;
    border-radius: 50%;
    box-shadow: $box_shadow;
    &.active {
      background: $deactive_color;
    }
    .wrap-info {
      display: none;
      position: absolute;
      width: $info_width; height: 100%;
      top: calc(100% + 6px); left: calc(-#{$info_width}/4);
      background: $overlay_color;
      border-radius: 3px;
      span {
        word-break: keep-all;
        color: $dark_primary_text_color;
      }
      &.hoverring {
        display: flex;
      }
    }
  }
}
</style>

<script>
import '@sjmc11/tourguidejs/src/scss/tour.scss'
import { TourGuideClient } from '@sjmc11/tourguidejs'
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')

export default {
  props: {
    currentMode: {
      type: String,
      required: true
    },
    targetObjectMode: {
      type: String,
      required: true
    },
    tutorial: { 
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    tools () {
      return this.targetObjectMode !== 'sprite' ?
      [
        { 
          mode: 'normal', icon: 'mdi-cursor-default', name: '選択ツール (V)',
          tg: {}
        },
        { 
          mode: 'translate', icon: 'mdi-arrow-all', name: '移動ツール (T)',
          tg: {
            tour: [
              '<p class="mb20">配置したオブジェクトは移動ツールで簡単に移動ができます！</p>',
              // '<iframe style="border-radius: 3px;" height="201" src="https://www.youtube.com/embed/s37esUVMuVY?loop=1&playlist=s37esUVMuVY&autoplay=1&mute=1&showinfo=0&rel=0&modestbranding=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>'
              '<video loop muted autoplay playsinline controls class="w-full">'
              + '<source src="/tutorial/tools_in_studio_1.mp4" type="video/mp4">'
              + '</video>'
            ].join(''),
            order: '1', group: 'tools_in_studio'
          }
        },
        {
          mode: 'rotate', icon: 'mdi-rotate-3d-variant', name: '回転ツール (R)',
          tg: {
            tour: [
              '<p class="mb20">回転ツールで角度の調整もできます！</p>',
              // '<iframe style="border-radius: 3px;" height="201" src="https://www.youtube.com/embed/uYgq9gqbelo?loop=1&playlist=uYgq9gqbelo&autoplay=1&mute=1&showinfo=0&rel=0&modestbranding=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>'
              '<video loop muted autoplay playsinline controls class="w-full">'
              + '<source src="/tutorial/tools_in_studio2.mp4" type="video/mp4">'
              + '</video>'
            ].join(''),
            order: '2', group: 'tools_in_studio'
          }
        },
        // { type: 'scale', icon: 'mdi-arrow-expand-all', name: '拡大ツール' },
      ] :
      [
        { 
          mode: 'normal', icon: 'mdi-cursor-default', name: '選択ツール',
          tg: {}
        },
        { 
          mode: 'translate', icon: 'mdi-arrow-all', name: '移動ツール',
          tg: {
            tour: '移動ツールを使うとオブジェクトを簡単に移動できます！',
            order: '1', group: 'tools_in_studio'
          }
        },
      ]
    }
  },
  data () {
    return {
      // tools: [
      //   { mode: 'normal', icon: 'mdi-cursor-default', name: '選択ツール' },
      //   { mode: 'translate', icon: 'mdi-arrow-all', name: '移動ツール' },
      //   { mode: 'rotate', icon: 'mdi-rotate-3d-variant', name: '回転ツール' },
      //   // { type: 'scale', icon: 'mdi-arrow-expand-all', name: '拡大ツール' },
      // ],
      // currentMode: 'normal',
      hoveredIconMode: null
    }
  },
  methods: {
    onTool (mode) {
      // this.currentMode = mode
      this.$emit('setTranformControlsMode', mode)
    },
    async startTutorial () {
      if (!this.tutorial
      || (this.tutorial && !this.tutorial.body.tools_in_studio)) {
        await this.sleep(800)
        const tg = new TourGuideClient({
          nextLabel: '次へ',
          prevLabel: '戻る',
          finishLabel: 'OK',
          targetPadding: 10
        })
        tg.onFinish(()=>{
          // この処理入れないともう一度チュートリアルを表示できない
          const tgDialog = document.getElementsByClassName('tg-dialog')[0]
          if (tgDialog) tgDialog.remove()
        })
        tg.start('tools_in_studio')

        let tutorialObj
        if (this.tutorial) {
          this.tutorial.body.tools_in_studio = true
          tutorialObj = this.tutorial
        } else {
          tutorialObj = {
            body: { tools_in_studio: true },
            createdAt: new Date(), createdBy: this.uid
          }
        }
        database.userTutorialCollection(this.uid).update('studio', tutorialObj)
      }
    }
  }
}
</script>